import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { payrollAPI } from '../services/api';

const fmt = n => n ? new Intl.NumberFormat('vi-VN').format(Math.round(n)) : '0';

const STATUS_CONFIG = {
  draft: { bg: '#f1f5f9', color: '#64748b', label: 'Draft' },
  calculated: { bg: '#eff6ff', color: '#1d4ed8', label: 'Đã tính' },
  pending_approval: { bg: '#fef9c3', color: '#ca8a04', label: 'Chờ duyệt' },
  approved: { bg: '#dcfce7', color: '#16a34a', label: 'Đã duyệt' },
  paid: { bg: '#f0fdf4', color: '#15803d', label: 'Đã thanh toán' },
};

export default function PayrollPage() {
  const [runs, setRuns] = useState([]);
  const [loading, setLoading] = useState(true);
  const [calculating, setCalculating] = useState(false);
  const [period, setPeriod] = useState(new Date().toISOString().substring(0,7));
  const navigate = useNavigate();

  const load = () => {
    setLoading(true);
    payrollAPI.list().then(r => setRuns(r.data.data)).finally(() => setLoading(false));
  };

  useEffect(() => { load(); }, []);

  const handleCalculate = async () => {
    setCalculating(true);
    try {
      await payrollAPI.calculate(period);
      load();
    } catch (err) {
      alert(err.response?.data?.message || 'Lỗi tính lương');
    } finally {
      setCalculating(false);
    }
  };

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
        <h1 style={{ fontSize: 22, fontWeight: 700, color: '#1e293b', margin: 0 }}>💰 Bảng lương</h1>
        <div style={{ display: 'flex', gap: 12, alignItems: 'center' }}>
          <input type="month" value={period} onChange={e => setPeriod(e.target.value)}
            style={{ padding: '9px 12px', border: '1px solid #e2e8f0', borderRadius: 8, fontSize: 14 }} />
          <button onClick={handleCalculate} disabled={calculating} style={{
            padding: '10px 22px', background: calculating ? '#93c5fd' : 'linear-gradient(135deg,#1e3a8a,#0891b2)',
            color: '#fff', border: 'none', borderRadius: 8, cursor: calculating ? 'not-allowed' : 'pointer',
            fontWeight: 600, fontSize: 14, display: 'flex', alignItems: 'center', gap: 8
          }}>
            {calculating ? '⏳ Đang tính...' : '⚡ Tính lương'}
          </button>
        </div>
      </div>

      {/* Info banner */}
      <div style={{ background: '#eff6ff', border: '1px solid #bfdbfe', borderRadius: 10, padding: '14px 18px', marginBottom: 20, fontSize: 13, color: '#1e40af' }}>
        💡 Hệ thống tự động tính lương theo <strong>Luật BHXH 2014</strong> (8% NV + 17.5% DN) và <strong>Luật TNCN</strong> với biểu thuế lũy tiến 7 bậc, giảm trừ gia cảnh 11 triệu + 4.4 triệu/người phụ thuộc. Dùng <strong>Decimal type</strong>, không float.
      </div>

      <div style={{ background: '#fff', borderRadius: 12, boxShadow: '0 1px 4px rgba(0,0,0,0.08)', overflow: 'hidden' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
          <thead>
            <tr style={{ background: '#f8fafc', borderBottom: '2px solid #e2e8f0' }}>
              {['Kỳ lương', 'Số NV', 'Tổng Gross', 'Tổng Net', 'BHXH DN', 'Trạng thái', 'Hành động'].map(h => (
                <th key={h} style={{ padding: '12px 14px', textAlign: 'left', fontSize: 12, fontWeight: 600, color: '#374151', textTransform: 'uppercase' }}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr><td colSpan={7} style={{ padding: 30, textAlign: 'center', color: '#94a3b8' }}>⏳ Đang tải...</td></tr>
            ) : runs.length === 0 ? (
              <tr><td colSpan={7} style={{ padding: 40, textAlign: 'center', color: '#94a3b8' }}>
                Chưa có bảng lương nào. Chọn tháng và nhấn "Tính lương".
              </td></tr>
            ) : runs.map(run => {
              const st = STATUS_CONFIG[run.status] || STATUS_CONFIG.draft;
              return (
                <tr key={run.id} style={{ borderBottom: '1px solid #f8fafc' }}>
                  <td style={{ padding: '14px 14px' }}>
                    <span style={{ fontWeight: 700, fontSize: 16, color: '#1e293b' }}>{run.period}</span>
                  </td>
                  <td style={{ padding: '14px 14px', textAlign: 'center', fontWeight: 600 }}>{run.employee_count}</td>
                  <td style={{ padding: '14px 14px', fontWeight: 600, color: '#1e293b' }}>{fmt(run.total_gross)} ₫</td>
                  <td style={{ padding: '14px 14px', fontWeight: 700, color: '#22c55e', fontSize: 15 }}>{fmt(run.total_net)} ₫</td>
                  <td style={{ padding: '14px 14px', color: '#7c3aed' }}>{fmt(run.total_bhxh_er)} ₫</td>
                  <td style={{ padding: '14px 14px' }}>
                    <span style={{ background: st.bg, color: st.color, padding: '4px 12px', borderRadius: 12, fontSize: 11, fontWeight: 600 }}>{st.label}</span>
                  </td>
                  <td style={{ padding: '14px 14px' }}>
                    <button onClick={() => navigate(`/payroll/${run.id}`)}
                      style={{ padding: '6px 14px', background: '#eff6ff', color: '#1d4ed8', border: '1px solid #bfdbfe', borderRadius: 6, cursor: 'pointer', fontSize: 12, fontWeight: 500 }}>
                      Xem chi tiết →
                    </button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
